const configs = [
	{
		host: 'bonusbay.de',
		apiUrl: 'https://api.thunderchild.es/',
		apiKey: 'bonusbay-de',
		locale: 'de-DE',
		currency: 'EUR',
		title: 'BonusBay.de',
		favicon: 'https://cdn.thunderchild.es/bonusbay-de/favicon.ico'
		// googleAnalyticsId: 'UA-121335242-1',
	}
]

const config = configs.find(config => config.host === window.location.hostname)

export default config || {
	host: 'localhost',
	apiUrl: 'https://api.thunderchild.es/',
	apiKey: 'bonusbay-de',
	locale: 'de-DE',
	currency: 'EUR',
	title: 'BonusBay.de',
	favicon: 'https://cdn.thunderchild.es/bonusbay-de/favicon.ico'
}



// WEBPACK FOOTER //
// ./src/utils/config.js